import React, { useState } from 'react';
import '../style/faq.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'; 

const faqData = [
  {
    question: "What is CarsChalao?",
    answer: "CarsChalao is your one-stop platform for the latest car news, comparisons, reviews, and buying guides."
  },
  {
    question: "Is EMI calculator accurate?",
    answer: "Our EMI calculator provides close estimates, but for exact figures, consult your bank or lender."
  },
  {
    question: "How can I inquire about car insurance?",
    answer: "Go to our Insurance Inquiry form and submit your details — we’ll get back to you soon!"
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-wrapper-premium">
      <div className="faq-container-v2">
        <div className="faq-header-v2">
          <span className="faq-eyebrow">Support</span>
          <h2 className="faq-headline">Frequently Asked Questions</h2>
          <p className="faq-desc">Quick answers to help you ride smart!</p>
        </div>

        <div className="faq-accordion-v2">
          {faqData.map((item, index) => (
            <div 
              className={`faq-item-v2 ${activeIndex === index ? 'is-open' : ''}`} 
              key={index}
            >
              <button 
                className="faq-trigger-v2" 
                onClick={() => toggleAnswer(index)}
                aria-expanded={activeIndex === index}
              >
                <span className="faq-question-v2">{item.question}</span>
                <div className="faq-icon-box">
                  <FontAwesomeIcon icon={activeIndex === index ? faMinus : faPlus} />
                </div>
              </button>
              
              <div className="faq-content-v2">
                <div className="faq-inner-v2">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;